import React, { useState } from 'react';
import styles from './index.module.sass';
//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import getLogin from '../Queries/getOpenOrder';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const AlertConfirm = (props) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [nextRoute, setNextRoute] = useState('');
  const [buttons, setbuttons] = useState(false);
  const [loadingOpenCart, setLoadingOpenCart] = useState(false);
  const { t } = useTranslation('sign');

  const {
    open = alertOpen,
    setOpen = setAlertOpen,
    title = '',
    text = '',
    loading,
    history,
    setAlertText,
  } = props;

  function handelDialog(action, messaje, route) {
    if (messaje) {
      setbuttons(true);
      setAlertText(messaje);
    }
    setOpen(action);
    if (route) setNextRoute(route);
    if (!action && nextRoute) history.push(nextRoute);
    history.push('/cart/consultancy/warehouse');
  }

  const handleClose = () => {
    setOpen(false);
  };

  async function confirm() {
    if (loadingOpenCart) return;
    setLoadingOpenCart(true);
    const response = await getLogin('S');
    const { getLoginResult = [] } = response || {};
    setOpen(false);

    if (getLoginResult.length > 0) {
      const {
        tipoMensaje = 'error',
        mensaje = '',
        folioPedido = '',
        usuarioOk = '',
        usuario = '',
        nombre = '',
        apPaterno = '',
        diasExpiracion = '',
        almacen = '',
      } = getLoginResult[0];

      if (tipoMensaje === 'error') {
        setLoadingOpenCart(false);
        setbuttons(true);
        setAlertText(mensaje);
        setOpen(true);
        return;
      }

      const now = new Date();
      const time = now.getTime();
      const expireTime = time + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = `folioPedido=${folioPedido};expires=${now.toUTCString()};path=/`;
      document.cookie = `usuarioOk=${usuarioOk};expires=${now.toUTCString()};path=/`;
      document.cookie = `usuario=${usuario};expires=${now.toUTCString()};path=/`;
      document.cookie = `kitName=${nombre} ${apPaterno};expires=${now.toUTCString()};path=/`;
      document.cookie = `warehouse=${almacen};expires=${now.toUTCString()};path=/`;
      document.cookie = 'pedidoCerrado=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

      setLoadingOpenCart(false);

      if (diasExpiracion !== '') {
        handelDialog(true, diasExpiracion, '/cart/consultancy/warehouse');
      } else history.push('/cart/consultancy/warehouse');
    } else {
      setLoadingOpenCart(false);
      setAlertText(t('loginFailed'));
      setOpen(true);
      return;
    }
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <DialogTitle id='alert-dialog-slide-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {!buttons ? (
          <>
            {!loading ? (
              <>
                <Button onClick={handleClose} className={styles.buttonCancel}>
                  Cancelar
                </Button>
                <Button onClick={() => confirm()} className={styles.buttonAcept}>
                  Aceptar
                </Button>
              </>
            ) : (
              <CircularProgress className={styles.loading} />
            )}
          </>
        ) : (
          <Button onClick={handleClose} color='primary'>
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertConfirm;
